/**
 * Labstep
 *
 * @module components/PurchaseOrder/Action/Delete
 * @desc Action to delete
 */

import { EntityActionDelete } from 'labstep-web/components/Entity/Action/Delete';
import type React from 'react';
import type { IPurchaseOrderActionDeleteProps } from './types';

export const PurchaseOrderActionDelete: React.FC<
  IPurchaseOrderActionDeleteProps
> = ({ purchaseOrder, actionComponentProps }) => (
  <EntityActionDelete
    actionComponentProps={actionComponentProps}
    entity={purchaseOrder}
  />
);
